var render = function render(_c,_vm){return _c('v-text-field',_vm._g(_vm._b({attrs:{"prepend-inner-icon":"mdi-badge-account","label":"Serial Number","outlined":"","hide-details":""}},'v-text-field',_vm.data.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }